@if (result) {
    <div class="container">
      <div class="tools">
        <input pInputText [(ngModel)]="query" placeholder="Search" (input)="onSearch()" [attr.data-testing-id]="resourceType + '-search-input'">
        @if (resourceType === 'screenshot' && !fileNotAccepted && !uploading && hasImageUploadPermission) {
          <input hidden type="file" class="imageupload-filechooser" #imageInput id="imageInput" accept="image/jpeg,image/png,image/jpg" (change)="selectFiles($event)" multiple>
          <div class="upload-button" (click)="imageInput.click()" data-testing-id="upload-image-btn">
            <fa-icon [icon]="'plus-circle'" class="icon"></fa-icon>
            Upload Image
          </div>
        }
        @if (resourceType === 'screenshot' && uploading && !fileNotAccepted){
          <p-progressSpinner class="uploading-spinner" strokeWidth="4"></p-progressSpinner>
          <div class="spinner-text">Uploading Image</div>
        }
        @if (resourceType === 'screenshot' && fileNotAccepted) {
          <div class="error-text">
            Only jpg, jpeg, png allowed!
          </div>
        }
        @if (resourceType === 'video' && !fileNotAccepted && !uploading && hasVideoUploadPermission) {
          <input hidden type="file" class="imageupload-filechooser" #videoInput id="videoInput" accept="video/mp4,video/webm" (change)="selectFiles($event)" multiple>
          <div class="upload-button" (click)="videoInput.click()">
            <fa-icon [icon]="'plus-circle'" class="icon"></fa-icon>
            Upload Video
          </div>
        }
        @if (resourceType === 'video' && uploading && !fileNotAccepted){
          <p-progressSpinner class="uploading-spinner" strokeWidth="4"></p-progressSpinner>
          <div class="spinner-text">Uploading Video</div>
        }
        @if (resourceType === 'video' && fileNotAccepted) {
          <div class="error-text">
            Only mp4 and webm allowed!
          </div>
        }
      </div>
      @if (result.results.length > 0){
        <div>
          <div class="result-wrapper" wmtDragDrop [dragEnabled]="(hasImageUploadPermission && this.resourceType === 'screenshot') || (hasVideoUploadPermission && this.resourceType === 'video')" (filesDropped)="dropFiles($event)">
            @for (r of result.results; track r.value.id) {
              <div class="data-result"
                   (mouseenter)="onRowMouseEnter(r.value.id)"
                   (mouseleave)="onRowMouseLeave(r.value.id)">
                @if (resourceType === 'screenshot') {
                  <div class="data-entry-thumb">
                    <img [src]="imageService.getImageUrl(r.value.id, 'small')" alt="" />
                  </div>
                }
                @if (resourceType === 'video' && r.value.data.state !== 'processing') {
                  <div class="data-entry-thumb">
                    <video [src]="videoRecordingService.getVideoUrl(r.value.id)"
                           muted
                           playsinline
                           preload="metadata"
                           (loadedmetadata)="onThumbLoaded($event, r.value.id)"
                           (timeupdate)="onThumbTimeUpdate($event)">
                    </video>
                    <div class="data-entry-thumb-progress">
                      <div class="data-entry-thumb-progress-fill"></div>
                    </div>
                  </div>
                }
                @if (resourceType === 'video' && r.value.data.state === 'processing') {
                  <div class="data-entry-thumb data-entry-thumb--placeholder">
                    <p-progressSpinner [style]="{ width: '20px', height: '20px' }"></p-progressSpinner>
                  </div>
                }
                <div class="data-entry-main">
                  <div class="data-entry-name" title="{{ r.value.name }}" [attr.data-testing-id]="r.value.id + '-' + resourceType + '-name'">
                    {{ r.value.name }}
                  </div>
                  <div class="data-entry-meta">
                    <span class="data-entry-date" [attr.data-testing-id]="r.value.id + '-' + resourceType + '-date'">
                      {{ r.value.createdOn | wmCalendarFormat }}
                    </span>
                    @if (resourceType === 'video' && r.value.data.duration) {
                      <span class="data-entry-dur" pTooltip="Duration" [attr.data-testing-id]="r.value.id + '-video-duration'">
                        {{ millisToMinutesAndSeconds(r.value.data.duration) }}
                      </span>
                    } @else if (resourceType === 'video' && r.value.data.state === 'processing') {
                      <p-progressSpinner [style]="{ width: '14px', height: '14px' }" pTooltip="Processing"></p-progressSpinner>
                    }
                  </div>
                </div>
                @if (resourceType === 'screenshot') {
                  <div class="data-entry-actions">
                    <button pButton type="button" class="data-entry-btn" [pTooltip]="config.payload.data.mode === 'normal' ? null : 'Open'" tooltipPosition="bottom" (click)="openScreenshot(r)" [attr.data-testing-id]="r.value.id + '-screenshot-open'">
                      <fa-icon [icon]="externalLink"></fa-icon>
                      {{config.payload.data.mode === 'normal' ? 'Open' : ''}}
                    </button>
                    @if (config.payload.data.mode === 'selection') {
                      <button
                              pButton
                              type="button"
                              class="data-entry-btn-animated"
                              [class.animate]="animateSelectButton"
                              (animationend)="onAnimationEnd()"
                              (click)="config.payload.callbacks['selected'](r.value.id, r.value.name); config.payload.data.mode = 'normal'"
                              [attr.data-testing-id]="r.value.id + '-screenshot-select'"
                      >
                        Select
                      </button>
                    }
                  </div>
                }
                @if (resourceType === 'video') {
                  <div class="data-entry-actions">
                    <button pButton type="button" class="data-entry-btn" (click)="openVideo(r)" [attr.data-testing-id]="r.value.id + '-video-open'">
                      <fa-icon [icon]="externalLink"></fa-icon>Open
                    </button>
                  </div>
                }
              </div>
            }
            <div class="dg-text">
              @if (resourceType === 'screenshot') {
                Drag and Drop Images here
              }
              @if (resourceType === 'video') {
                Drag and Drop Videos here
              }
            </div>
          </div>
          <div class="paginator">
            <p-paginator [first]="firstObject"
                         [rows]="rows"
                         [totalRecords]="totalItems"
                         (onPageChange)="onPageChange($event)"
                         [showCurrentPageReport]="true"
                         currentPageReportTemplate="{first} - {last} of {totalRecords}"
                         [showPageLinks]="false"
                         [showFirstLastIcon]="true"
                         [showJumpToPageDropdown]="false"
                         [rowsPerPageOptions]="[4, 8, 12, 16]"
                         styleClass="transparent-bg"
                         dropdownAppendTo="body"
            ></p-paginator>
          </div>
        </div>
      } @else if (query.length === 0 && result.results.length === 0) {
        <div class="media-browser-msg">
          @if (resourceType === 'screenshot') {
            No images found in this project.
          }
          @if (resourceType === 'video') {
            No videos found in this project.
          }
        </div>
      } @else if (query.length >= 3 && result.results.length === 0) {
        <div class="media-browser-msg">
          @if (resourceType === 'screenshot') {
            No images found for query '{{query}}'.
          }
          @if (resourceType === 'video') {
            No videos found for query '{{query}}'.
          }
        </div>
      } @else if (query.length > 0 && query.length < 3) {
        <div class="media-browser-msg">
          Enter at least 3 characters to search.
        </div>
      } @else {
        <div class="media-browser-msg">
          <p-progressSpinner></p-progressSpinner>
          <div>Searching...</div>
        </div>
      }
    </div>
}
@if (!result && searchFailed) {
  <a>Service failed.</a>
}

